<template>
	<div class="container">
		<div class="controls-container" v-if="showButtons">
			<v-btn @click="searchVehicles" prepend-icon="mdi-sail-boat" text="Vehicles">
			</v-btn>
			<v-btn @click="searchMissions" prepend-icon="mdi-help-rhombus-outline" text="Missions">
			</v-btn>

		</div>
		<v-card :loading="loading">
			<MissionsList v-if="!showButtons && !vehiclesOrMissions" @back="showButtons = true" :list="missions"
				@add="($event) => { emit('add', $event); }">
			</MissionsList>
			<VehiclesList v-if="!showButtons && vehiclesOrMissions" @back="showButtons = true" :list="vehicles"
				@search="searchMissionByVehicle($event)">
			</VehiclesList>
		</v-card>

	</div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import axios from 'axios';
import { storeToRefs } from 'pinia';
import { useSearchMissionStore } from '@/store/searchMissionStore';
import MissionsList from './MissionsList.vue';
import VehiclesList from './VehiclesList.vue';

const emit = defineEmits(['add']);
const props = defineProps(['missions', 'vehicles', 'selectedMissions'])
const searchMissionStore = useSearchMissionStore()


const { missions, vehicles } = storeToRefs(searchMissionStore);

const showButtons = ref(true);
const loading = ref(false);

const vehiclesOrMissions = ref(true);

axios.defaults.headers.common = {
	Authorization: `${localStorage.getItem('token')}`
};


const searchVehicles = async () => {
	showButtons.value = false;
	loading.value = true;

	vehiclesOrMissions.value = true;
	await searchMissionStore.getAllVehicles();
	loading.value = false;


};

const searchMissions = async () => {
	showButtons.value = false;

	loading.value = true;
	vehiclesOrMissions.value = false;
	await searchMissionStore.getAllMissions();

	loading.value = false;


};

const searchMissionByVehicle = async (vehicle) => {
	loading.value = true;

	await searchMissionStore.getMissionsByVehicle(vehicle.id);
	vehiclesOrMissions.value = false;
	loading.value = false;
};



</script>

<style lang="stylus" scoped>
	@import("../../assets/css/generalColors.styl")
	.container
		padding 10px
		background-color third-color
		border-radius 10px
		margin-top 8px
		-webkit-box-shadow 0px 0px 11px 0px rgba(0,0,0,0.15)
		-moz-box-shadow 0px 0px 11px 0px rgba(0,0,0,0.15)
		box-shadow 0px 0px 11px 0px rgba(0,0,0,0.15)

		.controls-container
			display flex

			button
				flex-grow 1
				min-height  50px
				border none
				background-color second-color 
				border-radius 8px
				color third-color
				font-weight bold
				font-size 1.2rem
				cursor pointer
				display flex
				justify-content center
				align-items center

				&:not(:last-child)
					margin-right 10px
				&:hover
					background-color main-color
				svg	
					width 30px
					margin-right 5px

</style>